import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import { Spin } from "antd";
import { Toast } from "react-bootstrap";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  agent_group_type_name: string | null;
  agent_group_type_id: number;
};

interface ErrorMessages {
  agent_group_type_name?: string[];
}


const EditAgentGroupType = () => {
  const routes = all_routes;
  const location = useLocation();
  const { id } = location.state || {};
  console.log(id);
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
   const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
      if((showSolidDangerToast || showSolidSuccessToast) === true){
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
      }
    },[toastMessage])
  const [data, setData] = useState({});

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const [newAdmin, setNewAdmin] = useState<Admin>({
    agent_group_type_name: null,
    agent_group_type_id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchCategoryData = async (id: string) => {
    const response = await fetch(
      `${webApi}/teammgmt/agent_group_types/${id}`,
      options
    );
     if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  // const fetchDispositions = async () => {
  //   const response = await fetch(
  //     `${webApi}/summercamp/dispositions_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  // const fetchTypeOfTicket = async () => {
  //   const response = await fetch(
  //     `${webApi}/wizklub/type_of_tickets_dropdown/`,
  //     options
  //   );
  //   return await response.json();
  // };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [categoryData] = await Promise.all([
        // fetchDispositions(),
        // fetchTypeOfTicket(),
        fetchCategoryData(id),
      ]);
      // setDispositions(dispositionsData);
      // setTypeOfTicket(typeOfTicketData);
      setNewAdmin(categoryData);
      // if (categoryData.disposition) {
      //   setSelectedDisposition(
      //     dispositionsData.find(
      //       (d: { student_disposition_id: any }) =>
      //         d.student_disposition_id === categoryData.disposition
      //     )
      //   );
      // }
      // if (categoryData.type_of_ticket) {
      //   setSelectedTypeOfTicket(
      //     typeOfTicketData.find(
      //       (t: { ticket_type_id: any }) =>
      //         t.ticket_type_id === categoryData.type_of_ticket
      //     )
      //   );
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };

  useEffect(() => {
    if (!checkPermission("change_agentgrouptype", "agentgrouptype")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
    }
  }, [userPermissions]);

  const updateData = async () => {
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/teammgmt/agent_group_types/${id}/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();
      setErrorMessage(errorData);
      setToastMessage(errorData.agent_group_type_name);
      if (toastMessage !== "") {
        setShowSolidDangerToast(true);
      }
      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading1(true);
    try {
      await updateData();
      navigate(routes.agentGroupTypesList);
    } catch (error) {
    } finally {
      setIsLoading1(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  // const dispositionOptions = dispositions.map((d) => ({
  //   value: d.student_disposition_id.toString(),
  //   label: d.disposition_name,
  // }));

  // const ticketTypeOptions = typeOfTicket.map((t) => ({
  //   value: t.ticket_type_id.toString(),
  //   label: t.ticket_type,
  // }));

  // const handleDispositionChange = (selected: Option | null) => {
  //   const disposition = dispositions.find(
  //     (d) => d.student_disposition_id === parseInt(selected?.value || "")
  //   );
  //   setSelectedDisposition(disposition || null);
  //   setNewAdmin({
  //     ...newAdmin,
  //     disposition: disposition?.student_disposition_id,
  //   });
  // };

  // const handleTicketTypeChange = (selected: Option | null) => {
  //   const ticketType = typeOfTicket.find(
  //     (t) => t.ticket_type_id === parseInt(selected?.value || "")
  //   );
  //   setSelectedTypeOfTicket(ticketType || null);
  //   setNewAdmin({
  //     ...newAdmin,
  //     type_of_ticket: ticketType?.ticket_type_id,
  //   });
  // };

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title"> Edit Agent Group Type</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.agentGroupTypesList}>Agent Group Type List</Link>
                  </li>
                  <li className="breadcrumb-item active">Edit Agent Group Type</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form
                      onSubmit={handleSubmit}
                      className="d-flex flex-column"
                    >
                      <div className="modal-body light-violet-bg d-flex">
                        {/* <div className="mb-3 me-3" style={{ width: "35%" }}>
                        <label className="form-label">Disposition</label>
                        <CommonSelect
                          className="select"
                          options={dispositionOptions}
                          onChange={handleDispositionChange}
                          defaultValue={dispositionOptions.find(
                            (option) =>
                              option.value ===
                              selectedDisposition?.student_disposition_id.toString()
                          )}
                        />
                      </div> */}
                        {/* <div className="mb-3" style={{ flex: "1 1 50%" }}>
                        <label className="form-label">Ticket Type</label>
                        <CommonSelect
                          className="select"
                          options={ticketTypeOptions}
                          onChange={handleTicketTypeChange}
                          defaultValue={ticketTypeOptions.find(
                            (option) =>
                              option.value ===
                              selectedTypeOfTicket?.ticket_type_id.toString()
                          )}
                        />
                      </div> */}
                      </div>

                      <div className="form-group mb-3" style={{ width: "35%" }}>
                        <label className="form-label">Agent Group Type Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.agent_group_type_name ? "is-invalid" : ""
                          }`}
                          name="agent_group_type_name"
                          placeholder="Agent Group Type Name"
                          onChange={handleInputChange}
                          value={newAdmin.agent_group_type_name || ""}
                        />
                         {errorMessage.agent_group_type_name && (
                        <div className="invalid-feedback">
                          {errorMessage.agent_group_type_name[0]}
                        </div>
                      )}
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          type="submit"
                          to={routes.agentGroupTypesList}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading1 ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default EditAgentGroupType;
